module.exports = __webpack_public_path__ + "assets/img/season5-3931da7a.png";